<template>
  <PageHeader :pageTitle="pageTitle" />
  <div class="container position-relative">
    <div
      v-if="html"
      class="contact shadow-sm p-4 w-50 mt-5 wysiwyg"
      v-html="html"
    ></div>
  </div>

  <GMapMap
    :center="{ lat: 41.707589585025794, lng: 44.79936952501847 }"
    :zoom="18"
    map-type-id="terrain"
    style="width: 100vw; height: 100vh"
    :options="{
      zoomControl: false,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false,
      disableDefaultUi: false,
      scrollwheel: false,
      styles: [
        {
          featureType: 'poi',
          stylers: [{ visibility: 'off' }],
        },
        { saturation: -100 },
      ],
    }"
  >
    <GMapMarker
      :key="index"
      v-for="(m, index) in markers"
      :position="m.position"
    />
  </GMapMap>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue";
import axios from "@/http";
import { ref } from "@vue/reactivity";
import { onMounted } from "@vue/runtime-core";
import { useStore } from "vuex";
import usePretendFetchData from "@/composables/usePretendFetchData";

export default {
  components: { PageHeader },
  setup() {
    const store = useStore();
    const html = ref(null);
    const pageTitle = ref(null);

    const setData = (data) => {
      pageTitle.value = data.title;
      html.value = data.body;
    };

    const markers = ref([
      {
        position: {
          lat: 41.70820909037509,
          lng: 44.79814747149477,
        },
      },
    ]);

    // onMounted(async () => {
    //   const res = await axios.post(
    //     "contact",
    //     {},
    //     { headers: { Authorization: `Bearer ${store.state.token}` } }
    //   );

    //   html.value = res.data.data.body;
    //   pageTitle.value = res.data.data.title;
    // });

    return { markers, html, pageTitle, setData };
  },
  beforeRouteEnter(to, from, next) {
    usePretendFetchData(to.name, false, (data) => {
      next((vm) => vm.setData(data));
    });
  },
};
</script>

<style>
/* .gm-style {
  height: 100%;
  width: 100%;
  border: 0;
  filter: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg'><filter id='grayscale'><feColorMatrix type='matrix' values='0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0'/></filter></svg>#grayscale"); 
  filter: gray;
  -webkit-filter: grayscale(99%);
} */
.contact {
  position: absolute;
  top: 0;
  right: 0;
  background-color: #fff;
  z-index: 9;
  border-bottom: solid 4px #3d5a80;
}
</style>